module.exports = new __parcel__URL__("retrospective.fc00e92a.png").toString();